import VueRouter from 'vue-router';
import routes from "./routes";
import { getRoutePageTitle } from './routeTitle';

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes: routes
});

router.afterEach((to) => {
    const usesDynamicEntityTitle = to.matched.some(
        (r) => r.meta && r.meta.dynamicEntityTitle
    );
    if (usesDynamicEntityTitle) {
        return;
    }
    document.title = getRoutePageTitle(to);
});

export default router;